function snakeCaseToCamelCase(str: string): string {
    return str.replace(
        /_([a-z])/g,
        (g: string) => g[1].toUpperCase(),
    );
}

export {
    snakeCaseToCamelCase,
};
